import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    clearButton: {
      backgroundColor: 'transparent',
      border: '1px solid',
      borderRadius: 5,
      color: 'white',
      padding: theme.spacing(2),
      margin: theme.spacing(2),
    },
    emailButton: {
      backgroundImage: 'linear-gradient(45deg, #ffd200, #ff7aab)',
      borderRadius: 5,
      color: 'white',
      padding: theme.spacing(2),
      margin: theme.spacing(2),
    },
    gradientSection: {
      alignItems: 'center',
      backgroundImage: 'linear-gradient(45deg, #ffd200, #ff7aab)',
      display: 'flex',
      height: 160,
      justifyContent: 'center',
      verticalAlign: 'middle',
    },
    heroImage: {
      width: '100%',
      height: 'auto',
      maxHeight: 700,
      objectFit: 'cover',
    },
    logo: {
      width: 230,
    },
    sectionHeading: {
      marginBottom: theme.spacing(4),
      textDecoration: `underline ${theme.palette.primary.main}`,
    },
    numberHighlight: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  })
)
